import { Component } from '@/app/pkg/component';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
type TypeSettings = {
  atom: AtomModel;
};
/**
 * Right mouse click Atom
 */
export class ContextMenu extends Component {
  public $el: JQuery;
  public data = {} as TypeSettings;
  /** constructor
   * @param element DOM
   * @param options Seting
   */
  constructor(element: HTMLElement, options?: TypeSettings) {
    super();

    this.$el = jQuery(element); // merge element to $el
    if (options) {
      // Merge options to data
      this.mergeData(options);
    }
  }
}
